// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'core-js/stable';
import 'regenerator-runtime/runtime';
import 'babel-polyfill';
import Vue from 'vue';
import VueI18n from 'vue-i18n';
import VueProgressBar from 'vue-progressbar';
import currency from 'v-currency-field';
import VueTheMask from 'vue-the-mask';

// local file
import App from './App';
import router from './router';
import store from './store';

// componentes globales
import CardToolTip from '@/common/util/CardToolTip';
import CardCurrentTime from '@/common/util/CardCurrentTime';
import AlertExtendible from '@/common/util/AlertExtendible.vue';
import TextExtendible from '@/common/util/TextExtendible.vue';
import GlobalDateInputPicker from '@/common/util/GlobalDateInputPicker.vue';

// Plugins
import EventBus from '@/common/plugins/event-bus';
import Util from '@/common/plugins/util';
import Storage from '@/common/plugins/storage';
import Datetime from '@/common/plugins/datetime';
import Filter from '@/common/plugins/filter';
import Message from '@/common/plugins/message/message';
import Loading from '@/common/plugins/loading/loading';
import Service from '@/common/plugins/service';
import Modal from '@/common/plugins/modal/modal';
import messages from '@/common/lang/';

import {
  Vuetify,
  VApp,
  VNavigationDrawer,
  VFooter,
  VList,
  VBtn,
  VIcon,
  VGrid,
  VMenu,
  VToolbar,
  VDialog,
  VAvatar,
  VDivider,
  VTooltip,
  VForm,
  VTextField,
  VRadioGroup,
  VCheckbox,
  VSelect,
  VAutocomplete,
  VCombobox,
  VTextarea,
  VChip,
  VSwitch,
  VDataTable,
  VCard,
  VBreadcrumbs,
  VAlert,
  VTabs,
  VDatePicker,
  VStepper,
  VSubheader,
  VProgressCircular,
  VExpansionPanel,
  transitions,
  VOverflowBtn,
  VImg,
  VSpeedDial
} from 'vuetify';
import '../node_modules/vuetify/src/stylus/app.styl';

const theme = {
  primary: '#01579B',
  secondary: '#0288d1',
  terciary: '#aa401d',
  accent: '#e49f51',
  info: '#0288D1',
  warning: '#fb8c00',
  error: '#f4516c',
  success: '#8BC34A',
  validate: '#8BC34A'
};

// Componentes globales
Vue.component('CardToolTip', CardToolTip);
Vue.component('CardCurrentTime', CardCurrentTime);
Vue.component('AlertExtendible', AlertExtendible);
Vue.component('TextExtendible', TextExtendible);
Vue.component('GlobalDateInputPicker', GlobalDateInputPicker);

// Config vuetify
Vue.use(Vuetify, {
  components: {
    VApp,
    VNavigationDrawer,
    VFooter,
    VList,
    VBtn,
    VIcon,
    VGrid,
    VMenu,
    VToolbar,
    VDialog,
    VAvatar,
    VDivider,
    VTooltip,
    VForm,
    VTextField,
    VRadioGroup,
    VCheckbox,
    VSelect,
    VAutocomplete,
    VCombobox,
    VTextarea,
    VChip,
    VSwitch,
    VDataTable,
    VCard,
    VBreadcrumbs,
    VAlert,
    VTabs,
    VDatePicker,
    VStepper,
    VProgressCircular,
    VSubheader,
    VExpansionPanel,
    transitions,
    VOverflowBtn,
    VImg,
    VSpeedDial
  },
  theme
});

// Plugins config
Vue.use(EventBus);
Vue.use(Util);
Vue.use(Storage, { appName: process.env.SITENAME || 'base' });
Vue.use(Message, { timeout: 6000 });
Vue.use(Loading);
Vue.use(Service, {
  apiUrl: process.env.API_URL,
  graphqlUrl: process.env.GRAPHQL_URL,
  authUrl: process.env.AUTH_URL,
  authToken: process.env.AUTH_TOKEN,
  djbrToken: process.env.DJBR_TOKEN,
  errorFormat: 'error'
});
Vue.use(Modal);
Vue.use(Datetime);
Vue.use(Filter);

// Progressbar config
Vue.use(VueProgressBar, {
  color: '#52d1e1',
  failedColor: '#fc4b6c',
  thickness: '4px'
});
Vue.use(currency, {
  thousands: '.',
  decimal: ',',
  decimalLength: 0,
  precision: 0,
  min: null,
  max: null,
  autoDecimalMode: false,
  defaultValue: null

});
Vue.use(VueTheMask);
// i18n config
Vue.use(VueI18n);
const i18n = new VueI18n({
  locale: process.env.LANG,
  messages
});

Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  i18n,
  components: { App },
  template: '<App/>'
});



// WEBPACK FOOTER //
// ./src/main.js